const MainURL = 'https://drumhi.com';

export default MainURL;